import { render, staticRenderFns } from "./AbstractSearch.vue?vue&type=template&id=87201210&"
import script from "./AbstractSearch.vue?vue&type=script&lang=js&"
export * from "./AbstractSearch.vue?vue&type=script&lang=js&"
import style0 from "./AbstractSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports